import { createSlotRecipe } from './runtime.js';

const selectConfig = {"name":"select","slots":["root","control","trigger","valueText","valueContent","chipSlot","subText","startAdornment","indicator","clearTrigger","positioner"],"defaultVariants":{"size":"md"},"variantMap":{"error":["true"],"fullWidth":["true"],"size":["lg","md","sm","xl"],"success":["true"],"warning":["true"]}}

export const select = /* @__PURE__ */ createSlotRecipe(selectConfig)